var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"section content"},[_c('div',{staticClass:"wrap-element",attrs:{"id":"dashboard"}},[_c('iframe',{staticClass:"wrapped-iframe",attrs:{"width":"100%","src":_vm.dashboardUrl,"allowfullscreen":""}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }